var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 364.5 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e0e0e0;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#bdbdbd;}.cls-5{fill:#2196f3;}.cls-6{fill:#1e88e5;}.cls-7{fill:#1976d2;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 366,
    height: 384
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327,0H39A18.63,18.63,0,0,0,20.38,18.63V76.29H345.62V18.63A18.63,18.63,0,0,0,327,0ZM95,37.47a11.59,11.59,0,1,1,11.59-11.59A11.58,11.58,0,0,1,95,37.47Zm176.08,0a11.59,11.59,0,1,1,11.58-11.59A11.58,11.58,0,0,1,271,37.47Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327,0H303.84a18.62,18.62,0,0,1,18.61,18.63V76.28h23.17V18.63A18.62,18.62,0,0,0,327,0Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M353.73,217.55H12.27L.84,79.6A26.31,26.31,0,0,1,27.06,51.11H338.94A26.31,26.31,0,0,1,365.16,79.6Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.94,51.11H315.77A26.31,26.31,0,0,1,342,79.6l-11.43,138h23.17l11.43-138a26.31,26.31,0,0,0-26.22-28.49Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.27,217.55H353.73l11.43,138A26.31,26.31,0,0,1,338.94,384H27.06A26.31,26.31,0,0,1,.84,355.51Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M365.16,355.51l-11.43-138H330.56l11.43,138A26.31,26.31,0,0,1,315.78,384h23.16a26.31,26.31,0,0,0,26.22-28.49Z",
    transform: "translate(-0.75)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M218.33,144.6l6.4,15.74a3.09,3.09,0,0,0,4,1.7l39.59-16.1V318.39a3.09,3.09,0,0,0,3.09,3.09h17a3.09,3.09,0,0,0,3.09-3.09V116.09a3.1,3.1,0,0,0-4.26-2.87L220,140.57a3.1,3.1,0,0,0-1.7,4Z",
    transform: "translate(-0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M180.77,169.88c0-32-28.61-58-63.77-58-29.09,0-54.49,18-61.72,43.33a3.07,3.07,0,0,0,2.31,3.83l16.64,3.68a3.07,3.07,0,0,0,3.59-2.05c4.77-15,20.77-25.61,39.18-25.61,22.39,0,40.6,15.61,40.6,34.78,0,18.36-16.68,33.43-37.74,34.7a3.07,3.07,0,0,0-2.86,3.08v17.19a3.07,3.07,0,0,0,2.86,3.08c21.06,1.26,37.74,16.34,37.74,34.69,0,19.18-18.21,34.78-40.6,34.78-20.25,0-37.55-12.94-40.24-30.11-.1-.62-.18-1.24-.24-1.87a3.07,3.07,0,0,0-3.06-2.8h-17a3.09,3.09,0,0,0-3.09,3.24c.11,1.69.29,3.37.55,5,2.18,13.89,9.86,26.59,21.61,35.75A67.69,67.69,0,0,0,117,320.57c35.16,0,63.77-26,63.77-58,0-18.94-10.05-35.78-25.56-46.37,15.51-10.58,25.56-27.42,25.56-46.36Z",
    transform: "translate(-0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google_calendar.126c92dc3ba5a056d345fe7df12cb63f.svg";
export { ForwardRef as ReactComponent };